// extracted by mini-css-extract-plugin
export default {"wrapper":"f1-z","availablePromoMessagesLabel":"g1-z","promoMessageList":"h1-z","promoMessage":"i1-z","appliedPromoMessage":"j1-z","promoMessageAmount":"k1-z"};